// Convert the per-activity `{ [stepIndex]: [tmpKey, ...] }` shape stored in
// state.data.pendingAttachments.byActivityId into the flat array shape the
// finalize endpoint expects: `[{ step, tmp_key }, ...]`. Returns undefined when
// there's nothing to send so callers can omit the body field entirely.
export function buildPendingAttachmentsBody(byStep) {
    if (!byStep) return undefined
    const entries = Object.entries(byStep).flatMap(([stepIndex, tmpKeys]) =>
        (tmpKeys ?? []).map((tmpKey) => ({
            step: Number(stepIndex),
            tmp_key: tmpKey,
        }))
    )
    return entries.length > 0 ? entries : undefined
}
